<template>
  <div class="card-resv-container">
    <div class="flex">
      <div style="flex:1"><span class="lp-title">예약번호</span><span class="lp-content">{{ card.order_num }}</span></div>
      <a :href="`order_detail?id=${card.id}`" target="_blank">
        <div class="flex flex-center unselect"><div>상세</div><i class="material-icons">keyboard_arrow_right</i></div>
      </a>
    </div>
    <div><span class="lp-title">예약자</span><span class="lp-content">{{ card.name }}</span></div>
    <div><span class="lp-title">휴대전화</span><span class="lp-content">{{ card.phone }}</span></div>
    <div><span class="lp-title">예약상품</span><span class="lp-content">{{ card.product.name }}</span></div>
    <div><span class="lp-title">수량</span><span class="lp-content">{{ card.ordered_count }}</span></div>
    <div class="flex" v-if="card.options.length>0">
      <div class="lp-title">옵션</div>
      <div class="lp-content"><span v-for="(opt,optIdx) in card.options" :key="'opt-'+optIdx">{{ opt.name }} {{opt.quantity}}<br></span></div>
    </div>
    <div><span class="lp-title">결제 상태</span><span class="lp-content">{{ card.pay_status_kor }}</span></div>
    <div><span class="lp-title">예약 상태</span><span class="lp-content">{{ card.order_status_kor }}</span></div>
    <div class="flex flex-center" style="margin-top:20px" v-if="card.status < 300">
      <!-- 결제완료, 승인대기 -->
      <button class="button is-primary"
              style="margin-right:8px"
              @click="openOrderStatusModal(200, '예약 확정')"
              v-if="card.status===100">예약 확정</button>
      <!-- 결제완료, 예약확정 -->
      <button class="button is-primary"
              style="margin-right:8px"
              @click="openOrderStatusModal(300, '이용 완료')"
              v-if="card.status===200">이용 완료</button>
      <!-- 결제완료, 취소완료(예약자 취소) 또는 취소완료(관리자 취소)-->
      <button class="button"
              style="margin-right:8px"
              @click="openOrderStatusModal(402, '예약 취소')"
              v-if="!(card.status===300 || card.status===401 || card.status===402)">예약 취소</button>
      <!-- 결제완료, 예약확정 -->
      <button class="button"
              @click="openOrderStatusModal(500, '노쇼 처리')"
              v-if="card.status===200">노쇼</button>
      <!-- 예약 취소 -->
      <div class="negative-div" v-if="card.status===400">
        <i class="material-icons" style="font-size:19px; margin-right:8px">warning</i>
        <span>예약자가 예약을 취소하였습니다.취소/환불 정책에 따라 결제 취소 처리해 주시기 바랍니다.</span></div>
    </div>

    <!-- 이용 상태 변경 -->
    <modal name="orderStatusModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <admin-box-item :title="title" :useTab="false" class="lp-modal-wrapper">
        <div><span v-if="title">{{ title }}</span> 하시겠습니까?</div>
        <div v-if="order_status===401 || order_status===402">* 결제 금액에 대한 취소는 결제 정보에서 처리해 주시기 바랍니다.</div>
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveOrderStatus">확인</button>
        </div>
      </admin-box-item>
    </modal>
  </div>
</template>

<script>
  export default {
    name: "CardResv",
    props: {
      card: {
        type: Object,
        default: function() {
          return {
            order_num: '20191210123458',
            user: {
              name: '소공녀',
              phone: '01012345678'
            },
            product: {
              name: '핸드메이드 가죽 가방 만들기'
            },
            ordered_count: 2,
            pay_status_kor: '결제 완료',
            status: 300
          }
        }
      }
    },
    data() {
      return {
        // 이용 상태
        order_status: 0,
        title: '',
      }
    },
    methods: {
      // 이용 상태 팝업 열기
      openOrderStatusModal (status, title) {
        this.title = '';
        this.order_status = status;
        this.title = title;
        // 예약 취소 예외처리
        // 예약 취소 요청 상태(400)일 경우 -> 변경할 상태값은 예약자 취소(401)
        if(this.card.status===400) {
          this.order_status = 401
        }
        this.$modal.show('orderStatusModal');
      },
      // 이용 상태 저장
      saveOrderStatus () {
        if(this.order_status===0) {
          this.toast('변경할 이용상태를 선택하세요');
          return;
        }
        this.$axios.post(this.getUrl('reservation/order/status/change'), {
          id: this.card.id,
          status: this.order_status
        }).then(res=> {
          if(res.status===200) {
            this.card.status = this.order_status;
            this.order_status = 0;
            this.$emit('refresh');
            this.toast('상태가 변경되었습니다.');
            this.$modal.hide('orderStatusModal');
            this.getData();
          }
        })
      },
    }
  }
</script>

<style lang="stylus" scoped>
  .card-resv-container
    border-radius 4px
    border 1px solid #e6e6e6
    padding 12px
    line-height 2rem
    font-size 13px
    margin-bottom 12px

  .lp-title
    font-weight 600
    margin-right 8px

  .negative-div
    display flex
    align-items center
    color $negative
</style>
